module.exports = __webpack_public_path__ + "img/analytics-cmbs-intel-lead-generation-1.c7dc8203.png";